import { useApiInfiniteQuery, type Api } from "../../../services/api";
import { useActiveLang } from "../../../domains/app/hooks/useActiveLang";

const limit = 20;

export type SearchJournalItem =
  Api["get"]["/webapp/public/journals/search"]["output"]["body"]["docs"][number];

export function useSearchJournalsQuery(
  searchValue: string,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const trimmed = searchValue.trim();
  const isEnabled = enabled && trimmed.length > 0;
  const { contentLang } = useActiveLang();

  const query = useApiInfiniteQuery(
    "/webapp/public/journals/search",
    isEnabled
      ? {
          query: {
            limit,
            search: trimmed,
            impactFactorMoreThan: 0,
            language: contentLang,
          },
        }
      : false
  );

  return {
    journals: query.state === "success" ? query.docs : [],
    total: query.state === "success" ? (query.total ?? 0) : 0,
    isLoading: query.state === "pending",
    isFetching: query.state === "idle" ? false : query.isFetching,
    hasNextPage: query.state === "success" && query.hasNextPage,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
  };
}
